<template>
  <v-select
    v-model="item"
    dir="rtl"
    :clearable="clearable"
    label="Name"
    :options="items"
    :filterable="false"
    :loading="loading"
    :reduce="x => x.Id"
    :disabled="disabled"
    @search="fetchOptions"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
     {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZUser',
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      val: '',
      loading: false,
    }
  },
  computed: {
    selectedItem() {
      return this.items.find(item => item.Id === this.item)
    },
    item: {
      get() {
        if (this.value && this.items.length === 0) {
          this.fetchOptions(null, this.value)
        }
        return this.val
      },
      set(newValue) {
        this.val = newValue
        this.$emit('input', newValue)
        this.$emit('change', this.items.find(item => item.Id === newValue))
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val
      }
    },
  },
  methods: {
    fetchOptions(search, id) {
      if (!search && this.items.length) return
      this.loading = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$http.post(
            this.$api.user.getlist, {
              Page: 1,
              PerPage: 50,
              Title: search,
              Id: id,
            },
        )
            .then(res => {
              this.items = res.data
              this.items.forEach(item => {
                let name = `${item.Id}.`
                if (item.Name || item.Family) {
                  if (item.Name) {
                    name += ` ${item.Name}`
                  }
                  if (item.Family) {
                    name += ` ${item.Family}`
                  }
                } else {
                  name += ' کاربر زیره'
                }

                this.$set(item, 'Name', name)
              })
              this.loading = false
            })
      }, 250)
    },
    onOpen() {
      this.fetchOptions()
    },
  },
}
</script>
